<script>
	// export let name;

	import { Router, Route, Link } from "svelte-routing";
	import Home from "./Home.svelte";
	import Priv from "./privacy.svelte";
	import Term from "./terms.svelte";

	// import Samle from "./pages/Samle.svelte";
	// import Sjef from "./pages/Sjef.svelte";
	// import LasterInn from "./LasterInn.svelte";

	export let url = ""; //This property is necessary declare to avoid ignore the Router
</script>

<svelte:head>
	<link
		href="https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500;700;800&display=swap"
		rel="stylesheet"
	/>
</svelte:head>

<Router {url}>
	<!-- <div class="nextPage">
		<nav>
			 <Link to="/">Giasdasd</Link>
			<Link to="samle">Samle</Link> 
		</nav>
	</div> -->

	<div>
		<!-- <Route path="sjef" component={Sjef} />
		<Route path="samle" component={Samle} /> -->
		<!-- <Route path="lasterInn" component={LasterInn} /> -->

		<!--for now the router just support case sensitive,
		   one workaround colud be add two time the route
		   Example.
		  <Route˘ path="About" component="{About}" /> 
	   -->
		<Route path="/"><Home /></Route>
		<Route path="/privacy"><Priv /></Route>
		<Route path="/terms"><Term /></Route>
	</div>
</Router>

<!-- <style>
	:global(body) {
		background-color: #AEE494;
		transition: background-color 0.3s
	}
	:global(body.d) {
		background-color: #AEE494;
		transition: background-color 0.3s
	}
	:global(body.dark-mode) {
		background-color: #1d3040;
		color: #bfc2c7;
	}
</style> -->
<style>
	:root {
		margin: 0px;
		padding: 0px;
		background-color: var(--bg, white);
	}
</style>
